module.exports = __webpack_public_path__ + "static/media/wijn-rood-glas copy.319bdc3a.png";